import React from 'react'
import * as request from 'superagent'
import moment from 'moment'
import DefaultPicture from '../../img/commons/default_picture.png'
import warningData from '../../img/icons/general-icons/icon_warning.png'
import PrintReport from '../../img/icons/general-icons/icono_print.png'
import SimulatorIC from '../../img/icons/general-icons/icono_simulador.png'
import SendReport from '../../img/icons/general-icons/icono_email.png'
import LZString from 'lz-string'
import { Link } from 'react-router'
import { ToastContainer, ToastMessage } from 'react-toastr'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class DashboardPersonalData extends React.Component {
  hexEncode(str) {
    var hex, i
    var result = ''
    for (i = 0; i < str.length; i++) {
      hex = str.charCodeAt(i).toString(16)
      result += ('000' + hex).slice(-4)
    }
    return result
  }

  sendFunction() {
    let endpoint = 'https://resultados.sicor.com.co/api/registrourl/'
    let obj = {
      cc: this.props.data.numeroDocumento,
      url: arguments[0]
    }

    request
      .post(endpoint)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization', 'iyvmG3ZFjMuinCYUeVgc')
      .send(obj)
      .end((err, res) => {
        if (err) console.log(err)
        else console.log(res)
        this.refs.container.success('Enviamos el simulador a la plataforma de resultados', '', {
          closeButton: true
        })
      })
  }

  getStyles() {
    var profilePicture = this.props.data.patientImage ? this.props.data.patientImage : DefaultPicture
    let styles = {
      img: {
        'background': 'url(' + profilePicture + ')'
      }
    }
    return Object.assign({}, styles.img)
  }
  compres(str) {
    return codec2.compress(str).then((result) => {
      return result
    })
  }
  render() {
    var profilePicture = this.props.data.patientImage ? this.props.data.patientImage : DefaultPicture
    var agePatient = this.props.data.patientAge + ' años '
    var urlPaciente = 'printableDashboard/' + this.props.data.numeroDocumento
    var urlDoctor = 'printableDiabetes/' + this.props.data.numeroDocumento
    debugger
    var obj = {
      arterialAge: this.props.data.arterialAge,
      biologicalAge: this.props.data.biologicalAge,
      chart1: this.props.data.chart1,
      chart2: this.props.data.chart2,
      fx_reserve: this.props.data.fx_reserve,
      percent_lost_capacity: this.props.data.percent_lost_capacity,
      medicalBMIData: this.props.data.medicalBMIData,
      medicalBalanceNeur: this.props.data.medicalData.balanceNeuroMuscularT,
      medicalCol: this.props.data.medicalCol,
      medicalColGlicemia: this.props.data.medicalColGlicemia,
      medicalColHDL: this.props.data.medicalColHDL,
      medicalColLDL: this.props.data.medicalColLDL,
      medicalColTotal: this.props.data.medicalColTotal,
      medicalColTrigliceridos: this.props.data.medicalColTrigliceridos,
      medicalCreatinina: this.props.data.medicalCreatinina,
      medicalData: this.props.data.medicalData,
      medicalFrecuenciaC: this.props.data.medicalFrecuenciaC,
      medicalPAParado: this.props.data.medicalPAParado,
      medicalPASentado: this.props.data.medicalPASentado,
      medicalPeso: this.props.data.medicalData.peso,
      numeroDocumento: this.props.data.numeroDocumento,
      patientAge: this.props.data.patientAge,
      patientBirthDay: this.props.data.patientBirthDay,
      patientGender: this.props.data.patientGender,
      patientFullName: this.props.data.patientFullName
    }
    let paciente = this.props.state.health.paciente
    let estadoDeSaludData = this.props.state.health._id
    let promSystolic = (this.props.state.health.sistoleParado + this.props.state.health.sistoleSentado) / 2;
    const { dolor, ansiedad, actividadesCotidianas, decaido, satisfaccion, depresion, peso, mets, altura, fuma, cuidadoPersonal, feliz, preocupacion, movilidad, balanceNeuroMuscularT } = this.props.data.medicalData
    const { itbDerecho, itbIzquierdo, vop, tiempoCincoM } = this.props.state.ShowAfecto
    // { balanc: '42', vop: '4', itbIzquierd: '1', itbDerecho: '1', frecuencia: '50', tiempoCincoM: '5', mets: '2', depresion: '10', satisfaccion: '10', feliz: '10', preocupacion: '10', decaido: '0', gender: 'f', peso: '90', altura: '180', fechaNacimiento: '1990-12-31T05:00:00.000Z', fuma: 'No', movilidad: '2', cuidadoPersonal: '1', actividadesCotidianas: '1', dolor: '1', ansiedad: '1', paciente: '5c51e60fadd425634ecad879', salud: 33, versionAlgoritmo: 'v1' }
    obj = { promSystolic, cc: this.props.data.numeroDocumento, paciente, estadoDeSaludData, tiempoCincoM: tiempoCincoM, vop: vop, itbDerecho: itbDerecho, itbIzquierdo: itbIzquierdo, dolor: dolor, ansiedad: ansiedad, mets: mets, movilidad: movilidad, peso: peso, fc: this.props.data.medicalFrecuenciaC, staticPeso: peso, staticFc: this.props.data.medicalFrecuenciaC, fuma: fuma, actividad: actividadesCotidianas, actividadesCotidianas: actividadesCotidianas, satisfaccion: satisfaccion, contribucion: depresion, feliz: feliz, preocupacion: preocupacion, depresion: decaido, status: 'peso', altura: altura, fechaNacimiento: this.props.data.patientBirthDay, balance: balanceNeuroMuscularT, versionAlgoritmo: 'v1', decaido: decaido, cuidadoPersonal: cuidadoPersonal, gender: this.props.data.patientData.genero, nombres: this.props.data.patientData.nombrecompleto, char: this.props.data.chart1, fx_reserve: this.props.data.fx_reserve }
    var old_simulador = {
      arterialAge: this.props.data.arterialAge,
      biologicalAge: this.props.data.biologicalAge,
      chart1: this.props.data.chart1,
      chart2: this.props.data.chart2,
      fx_reserve: this.props.data.fx_reserve,
      percent_lost_capacity: this.props.data.percent_lost_capacity,
      medicalBMIData: this.props.data.medicalBMIData,
      medicalBalanceNeur: this.props.data.medicalData.balanceNeuroMuscularT,
      medicalCol: this.props.data.medicalCol,
      medicalColGlicemia: this.props.data.medicalColGlicemia,
      medicalColHDL: this.props.data.medicalColHDL,
      medicalColLDL: this.props.data.medicalColLDL,
      medicalColTotal: this.props.data.medicalColTotal,
      medicalColTrigliceridos: this.props.data.medicalColTrigliceridos,
      medicalCreatinina: this.props.data.medicalCreatinina,
      medicalData: this.props.data.medicalData,
      medicalFrecuenciaC: this.props.data.medicalFrecuenciaC,
      medicalPAParado: this.props.data.medicalPAParado,
      medicalPASentado: this.props.data.medicalPASentado,
      medicalPeso: peso,
      numeroDocumento: this.props.data.numeroDocumento,
      patientAge: this.props.data.patientAge,
      patientBirthDay: this.props.data.patientBirthDay,
      patientGender: this.props.data.patientGender,
      patientFullName: this.props.data.patientFullName
    }
    let oldStr = this.hexEncode(LZString.compress(JSON.stringify(old_simulador)))
    let str = JSON.stringify(obj)
    str = LZString.compress(str)
    str = this.hexEncode(str)
    var url = (window.location.hostname === 'localhost') ? 'http://localhost:3001/s/?' : window.location.hostname === 'core3test.integ.ro' ? window.location.origin + '/simulador/?' : window.location.origin + '/simulator/?'
    var urlOther = (window.location.hostname === 'localhost') ? 'http://localhost:3001/?' : window.location.hostname === 'core3test.integ.ro' ? window.location.origin + '/simulator/?' : window.location.origin + '/simulador/?'
    var cloneObj = url + str
    var oldUrl = urlOther + oldStr
    var rol = localStorage.rol_name
    // console.log(moment().format("DD-MM-YYYY HH:MM:ss"),this.props.state)
    this.props
    return (
      <div className='basic-data-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <div className='patient-personal-information'>
          <div className='image-container'>
            <div id='photo' className='patient-photo' style={this.getStyles()}> </div>
          </div>
          <div className='data-container'>
            <label className='data' id='patientFullName'>{this.props.data.patientFullName}</label>
            <label className='data' id='patientDocument'>{this.props.data.patientIdentification}</label>
            <label className='data data-text-label' id='patientAge'>Edad: {agePatient}{(this.props.data.patientAge < 25 || this.props.data.patientAge > 80) ? <img className='range-warning-image' src={warningData} /> : null}</label>
            {this.props.state.muerto ?
              <label className='dead'>Falleció</label> : ''}
            {this.props.state.muerto ? <label className='date'> {this.props.state.date_muerte}</label> : ''}
          </div>
        </div>
        <div className='generate-report'>
          <div className='link-report'>
            <Link to={urlPaciente} className='link-report-data' target='_blank'>
              <img className='report-img' src={PrintReport} />
              <span>Informe paciente</span>
            </Link>
          </div>
          <div className='link-report'>
            <Link to={urlDoctor} className='link-report-data' target='_blank'>
              <img className='report-img' src={PrintReport} />
              <span>Informe doctor</span>
            </Link>
          </div>
          <div className='link-report'>
            <a href={cloneObj} className='link-report-data' target='_blank'>
              <img className='report-img' src={SimulatorIC} />
              <span>Simulación</span>
            </a>
          </div>
          {rol === 'admin' ? (
            <div className='link-report'>
            <a href={oldUrl} className='link-report-data' target='_blank'>
              <img className='report-img' src={SimulatorIC} />
              <span>Simulación 0.1</span>
            </a>
          </div>
          ) : null}

        </div>
      </div>
    )
  }
}

/* Validate Props */
DashboardPersonalData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardBasicData.js